import { Mark } from '@tiptap/core';
import * as commands from './commands';
import { getParentByAttribute } from '../helpers/getParentByAttribute';

export const HighlightSuggestion = Mark.create({
  name: 'highlightSuggestion',

  addCommands() {
    return {
      setHighlights: commands.setHighlights.bind(this),
      addHighlight: commands.addHighlight.bind(this),
      replaceHighlight: commands.replaceHighlight.bind(this),
      removeAllHighlights: commands.removeAllHighlights.bind(this),
    };
  },

  onCreate() {
    const attr = 'data-highlight-id';
    const findId = (el) => getParentByAttribute(el, attr)?.getAttribute(attr) || '';

    this.editor.view.dom.addEventListener('mouseover', (event) => {
      if (event.buttons) {
        return;
      }

      const id = findId(event.target);
      if (id && !this.storage.highlights[id]?.hide) {
        this.options.onMouseOver({ id, event, tiptap: this.editor });
      }
    });

    this.editor.view.dom.addEventListener('mouseout', (event) => {
      const id = findId(event.target);
      if (id) {
        this.options.onMouseOut({ id, event, tiptap: this.editor });
      }
    });
  },

  addOptions() {
    return {
      onMouseOver: () => null,
      onMouseOut: () => null,
    };
  },

  addStorage() {
    return {
      highlights: {},
    };
  },

  addAttributes() {
    return {
      id: {
        default: '',
        renderHTML: ({ id }) => ({ 'data-highlight-id': id }),
      },
      className: {
        default: '',
        renderHTML: ({ className }) => ({ class: `hl-${className}` }),
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },
});
